import React, { useState, Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainLayout from "./components/layout/MainLayout";
import SearchModal from "./components/modals/SearchModal";
import Loading from "./components/common/Loading";
import TrendingTickerMajor from "./components/TrendingTicker_major";
import WhalePortfolioTicker from "./components/WhalePortfolioTicker";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

// Lazy load pages
const TrendingPage = lazy(() => import("./pages/TrendingPage"));
const TokenPage = lazy(() => import("./pages/TokenPage"));
const PortfolioPage = lazy(() => import("./pages/PortfolioPage"));
const PumpFunPage = lazy(() => import("./pages/PumpFunPage"));
const EvmWhalesPage = lazy(() => import("./pages/EvmWhalesPage"));
const SolanaWhalesPage = lazy(() => import("./pages/SolanaWhalesPage"));
const UsdcMintsPage = lazy(() => import("./pages/UsdcMintPage"));
const UsdtMintsPage = lazy(() => import("./pages/UsdtMintPage"));
const AiAnalyzerPage = lazy(() => import("./pages/AiAnalyzerPage"));
const TokenExplorerPage = lazy(() => import("./pages/TokenExplorer"));
const AddressExplorer = lazy(() => import("./pages/AddressExplorer"));
const TxDetails = lazy(() => import("./pages/TxDetails"));
const MemeScannerPage = lazy(() => import("./pages/MemeScanner"));
const MarketAnalysis = lazy(() => import("./pages/MarketAnalysis"));
const Intel = lazy(() => import("./pages/Intel"));
const LetsBonkPage = lazy(() => import("./pages/LetsbonkPage"));
const FourMemePage = lazy(() => import("./pages/FourmemePage"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const ProfilePage = lazy(() => import("./pages/ProfilePage"));
const AveTrendingPage = lazy(() => import("./pages/AveTrendingPage"));
const FourmemeBoard = lazy(() => import("./pages/FourmemeBoard"));
const LetsBonkBoard = lazy(() => import("./pages/LetsBonkBoard"));
const AdminPanel = lazy(() => import("./pages/AdminPanel"));
const BscKol = lazy(() => import("./pages/BscKol"));
const About = lazy(() => import("./pages/About"));
const NewsPage = lazy(() => import("./pages/News"));
const FearAndGreedIndex = lazy(() => import("./pages/FearAndGreedIndex"));
const TopPerformance = lazy(() => import("./pages/TopPerformance"));
const CoinUnlocks = lazy(() => import("./pages/CoinUnlocks"));
const MarketHeatmap = lazy(() => import("./pages/MarketHeatmap"));



const App = () => {
  const [isSearchModalOpen, setSearchModalOpen] = useState(false);

  const [showTickers, setShowTickers] = useState(true);

  return (
    <Router>
      <div className="min-h-screen text-white bg-black">
      
        {/* Conditional Rendering */}
        {showTickers && (
          <>
            <TrendingTickerMajor />
            <WhalePortfolioTicker />
          </>
        )}

        {/* Toggle Button */}
        <div className="flex justify-center p-2">
          <button
            onClick={() => setShowTickers((prev) => !prev)}
            className="block px-10 py-1 text-sm font-medium text-white bg-black rounded-b-md border border-t-0 transition border-white/20 hover:bg-white/5 lg:hidden"
          >

            {showTickers ? <FaChevronUp /> : <FaChevronDown />}

          </button>
        </div>

        <MainLayout openSearchModal={() => setSearchModalOpen(true)}>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/:chainId" element={<TrendingPage />} />
              <Route path="/:chainId/:tokenAddress" element={<TokenPage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/pumpfun" element={<PumpFunPage />} />
              <Route path="/evm-whales" element={<EvmWhalesPage />} />
              <Route path="/solana-whales" element={<SolanaWhalesPage />} />
              <Route path="/usdt-mints" element={<UsdtMintsPage />} />
              <Route path="/usdt-mint" element={<UsdtMintsPage />} />
              <Route path="/usdc-mints" element={<UsdcMintsPage />} />
              <Route path="/ai-analyzer" element={<AiAnalyzerPage />} />
              <Route path="/explorer" element={<TokenExplorerPage />} />
              <Route path="/address/:value" element={<AddressExplorer />} />
              <Route path="/address" element={<AddressExplorer />} />
              <Route path="/tx/:hash" element={<TxDetails />} />
              <Route path="/meme" element={<MemeScannerPage />} />
              <Route path="/market-analysis" element={<MarketAnalysis />} />
              <Route path="/intel" element={<Intel />} />
              <Route path="/bonkfun" element={<LetsBonkPage />} />
              <Route path="/fourmeme" element={<FourMemePage />} />
              <Route
                path="/explorer/:tokenAddress"
                element={<TokenExplorerPage />}
              />
              <Route path="/trending" element={<TrendingPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/ave-trending" element={<AveTrendingPage />} />
              <Route path="/admin" element={<AdminPanel />} />

              <Route path="/fourmeme2" element={<FourmemeBoard />} />
              <Route path="/letsbonk2" element={<LetsBonkBoard />} />
              <Route path="/bsc-kol" element={<BscKol />} />
              <Route path="/about" element={<About />} />
              <Route path="/news" element={<NewsPage/>}/>
              <Route path="/fearandgreedindex" element={<div className="px-4 py-6 mx-auto max-w-5xl"><FearAndGreedIndex embed /></div>} />
              <Route path="/top-performance" element={<TopPerformance />} />
              <Route path="/coin-unlocks" element={<CoinUnlocks />} />
              <Route path="/heatmap" element={<MarketHeatmap />} />
            </Routes>
          </Suspense>
        </MainLayout>

        <SearchModal
          isOpen={isSearchModalOpen}
          onClose={() => setSearchModalOpen(false)}
        />
      </div>
    </Router>
  );
};

export default App;
